export const getJurisdictionCreationObject = (data) => {
  let objectTemp = {
    name: data.name,
  };

  return objectTemp;
};

export const getJurisdictionUpdatenObject = (data) => {
  let objectTemp = {
    name: data.name,
  };

  return objectTemp;
};
